import { actionCreator, asyncActionsCreator } from '../common/utils';
import { UndoEntry, UndoneTask, UndoStep } from './types';
import { SourceEvent } from '../events/types';

const asyncActions = asyncActionsCreator('@@undo');
const action = actionCreator('@@undo');

// An undoable change went through: keep it and offer Undo in a toast with this message. `silent`: no toast, for plain
// drags and edits that happen all the time (a toast on every one would get annoying, Petr 2026-10-24); the calendar's
// Undo button and Cmd+Z still take them back. `toast`: what the toast says instead of the message, which stays the
// change's name on the button. `replaces`: a step this one takes the place of (a popup's date, then its time).
export const record = action<{
  entry: UndoEntry;
  message: string;
  silent?: boolean;
  toast?: string;
  replaces?: UndoEntry;
}>('RECORD');

// Everything forgotten: the calendar or the term reloaded under it.
export const clear = action<undefined>('CLEAR');

// A step that turned out to change nothing after all (a popup's edits put back as they were).
export const discard = action<UndoEntry>('DISCARD');

// Cmd+Z and the calendar's Undo button: the newest step, once the changes still on their way are in.
export const undoLatest = action<undefined>('UNDO_LATEST');

// Takes back this change, whichever step it is: Cmd+Z and the button pass the newest, a toast's Undo button its own.
export const undo = asyncActions<UndoEntry, undefined, string>('UNDO');

// An Undo that couldn't reach the server: the step goes back where it was, to be tried again.
export const reinsert = action<UndoStep>('REINSERT');

// `usedSessionId`: the session a completion from its popup had marked used, unmarked again.
export const tasksUndone = action<{ action: 'DELETE' | 'COMPLETE'; tasks: UndoneTask[]; usedSessionId?: number }>(
  'TASKS_UNDONE'
);

export const eventsRestored = action<{ restored: SourceEvent[]; removeIds: string[] }>('EVENTS_RESTORED');
